import { FC } from 'react'

import { RequestByIdApiType } from '@/api/models/requests'
import { FileUploadedList } from '@/components/shared/file-viewer'

type Props = {
  files: RequestByIdApiType['files']
  title?: string
}

const ContentBlockFiles: FC<Props> = ({ files, title = 'Файлы' }) => {
  const filteredFiles = files?.filter(files => files.name) || []

  return (
    <>
      {filteredFiles.length > 0 && (
        <div data-testid="request-files-block-id">
          <div className="mb-8 font-bold text-grey-90 text-16">{title}</div>

          <FileUploadedList files={filteredFiles} />
        </div>
      )}
    </>
  )
}

export default ContentBlockFiles
